import React from 'react';
import { NotFoundMessage } from './styles';

export const EmptyLogs = () => (
  <NotFoundMessage
    component="h1"
    variant="h4"
    align="center"
  >
    No data. Change the selection or the date range.
  </NotFoundMessage>);
